var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{staticClass:"clsScroll",attrs:{"justify-center":""}},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"hide-actions":"","disable-initial-sort":""},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_c('tr',_vm._l((props.headers),function(header){return _c('th',{key:header.text,staticClass:"column sortable text-xs-center"},[_c('span',[_vm._v(_vm._s(header.text))])])}),0)]}},{key:"items",fn:function(props){return [_c('td',{class:[
            'text-xs-center',
            props.item.id == _vm.transId ? 'missing-trans-pointer' : '',
          ]},[_vm._v("\n          "+_vm._s(props.index + 1)+"\n        ")]),_c('td',{class:[
            'text-xs-center',
            props.item.id == _vm.transId ? 'missing-trans-pointer' : '',
          ]},[_vm._v("\n          "+_vm._s(props.item.trans_ticket_no ? props.item.trans_ticket_no : "--")+"\n        ")]),_c('td',{class:[
            'text-xs-center',
            props.item.id == _vm.transId ? 'missing-trans-pointer' : '',
          ]},[_vm._v("\n          "+_vm._s(props.item.app ? props.item.app.toUpperCase() : "--")+"\n        ")]),_c('td',{class:[
            'text-xs-center',
            props.item.id == _vm.transId ? 'missing-trans-pointer' : '',
          ]},[_vm._v("\n          "+_vm._s(props.item.card_no ? props.item.card_no : "--")+"\n        ")]),_c('td',{class:[
            'text-xs-center',
            props.item.id == _vm.transId ? 'missing-trans-pointer' : '',
          ]},[_vm._v("\n          "+_vm._s(props.item.date ? props.item.date : "--")+"\n        ")]),_c('td',{class:[
            'text-xs-center',
            props.item.id == _vm.transId ? 'missing-trans-pointer' : '',
          ]},[_vm._v("\n          "+_vm._s(props.item.time ? props.item.time : "--")+"\n        ")]),_c('td',{class:[
            'text-xs-center',
            props.item.id == _vm.transId ? 'missing-trans-pointer' : '',
          ]},[_vm._v("\n          "+_vm._s(props.item.transaction_type
              ? props.item.transaction_type.toUpperCase()
              : "--")+"\n        ")]),_c('td',{class:[
            'text-xs-center',
            props.item.id == _vm.transId ? 'missing-trans-pointer' : '',
          ]},[_vm._v("\n          "+_vm._s(props.item.prev_bal
              ? _vm.$amountInPeso(props.item.prev_bal)
              : _vm.$amountInPeso(0))+"\n        ")]),_c('td',{class:[
            'text-xs-center',
            props.item.id == _vm.transId ? 'missing-trans-pointer' : '',
          ]},[_vm._v("\n          "+_vm._s(props.item.amount
              ? _vm.$amountInPeso(props.item.amount)
              : _vm.$amountInPeso(0))+"\n        ")]),_c('td',{class:[
            'text-xs-center',
            props.item.id == _vm.transId ? 'missing-trans-pointer' : '',
          ]},[_vm._v("\n          "+_vm._s(props.item.remaining_bal
              ? _vm.$amountInPeso(props.item.remaining_bal)
              : _vm.$amountInPeso(0))+"\n        ")])]}}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }